import { Mask } from 'maska';

/** An empty string when there is no number: the mask alone renders a missing one as "+1 (". */
export function formatPhoneNumber(phone?: string | null): string {
  return phone ? new Mask({ mask: '+1 (###) ###-####' }).masked(phone) : '';
}

/**
 * Digits-only form with a leading US country code dropped, for comparing two phone values
 * regardless of masking (e.g. an InputPhone value vs a stored E.164 number).
 */
export function normalizePhoneNumber(phone?: string | null): string {
  return (phone || '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
}
